export const SAVE_CHARTS = 'SAVE_CHARTS';

export const ChartsReducer = (state, action) => {
  switch (action.type) {
    case SAVE_CHARTS:
      return {
        ...state,
        ...action.payload
      };
    default:
      return state;
  }
};
